<template>
  <div style="position: fixed; width: 100%; height: 100%; cursor: pointer; bottom: 20px; right: 20px; padding: 10px; background-color: #C4EACF; color:black; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px gray;">
    <div style="position: absolute; width: 90%; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: white;">
      <div style="width: 100%; height: 100%;">
        <div style="height: 50px; width:100%; line-height: 50px; font-weight: bold; font-size: 30px;">
          Sending Email
        </div>

        <div style="width: 100%; height: calc(100% - 100px); overflow-y: scroll;">
          <div class="container text-left">
            <div class="row">
              <div class="col-12">Email (2명이상이면 ,(콤마)로 구분)
                <input v-model="item.to" class="form-control"/>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="margin-top:20px;">
                이메일 제목:
                <input class="form-control" v-model="item.subject"/>
              </div>
              <div class="col-12" style="margin-top:20px;">
                이메일 내용:
                <textarea class="form-control" v-model="item.body" rows="5"/>
              </div>
              <div class="col-6" style="margin-top:20px;">
                첨부문서
                <div style="width: 100%; min-height: 50px; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">
                  <div style="padding:5px; border: 1px solid grey; float:left; margin-right:10px;" v-for="(doc, di) in item.documents">{{doc.title}} <span v-on:click="removeEmailDocItem(di)"><i class="fas fa-trash"></i></span></div>
                </div>
              </div>
              <div class="col-6" style="margin-top:20px;">
                문서리스트 (첨부할 문서를 선택해주세요)
                <div style="width: 100%; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">
                  <template v-for="(doc, di) in documents">
                    <div v-if="isDocumentSelected(doc) === false" style="padding:5px; border: 1px solid grey; float:left; margin-right:10px; margin-bottom: 10px;"  v-on:click="addEmailDocItem(doc)">{{doc.title}}</div>
                  </template>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div class="container" style="height: 50px; width: 100%; line-height: 50px;">
          <div class="row">
            <div class="col-3 text-left">
              <button class="btn btn-dark" @click="closeView">Close</button>
            </div>
            <div class="col-9 text-right">
              <button class="btn btn-success" @click="sendEmail">Send</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendEmailToCustomer} from "../api/request";
import {showDialog} from "../api/utils";

export default {
  name: "EmailForm",
  props: {
    item: {
      type: Object,
      default: function() { return null; }
    },
    documents: {
      type: Array,
      default: function() { return[]; }
    },
    onClose: {
      type: Function,
      default: null,
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    sendEmail: function() {
      let self = this;
      let item = JSON.parse(JSON.stringify(this.item));
      item.body = item.body.replaceAll('\n', "<br/>");
      sendEmailToCustomer(item)
        .then(function(data) {
          showDialog(data.message);
          if(self.onClose !== null) {
            self.onClose();
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    isDocumentSelected: function(doc) {
      for(let i = 0 ; i < this.item.documents.length ; i++) {
        if(this.item.documents[i].url === doc.url) {
          return true;
        }
      }
      return false;
    },
    addEmailDocItem: function(doc) {
      this.item.documents.push(JSON.parse(JSON.stringify(doc)));
    },
    removeEmailDocItem: function(index) {
      this.item.documents.splice(index, 1);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EmailForm.vue